/**
 * One list's address (`/lists/$listId`): `?q=` the words its search holds,
 * `?entry=` the entry open in the panel beside the table, `?edit=true` while
 * that entry is being changed there. Kept apart from the page, so the route
 * does not load the page before it is opened.
 */
import { z } from 'zod';

export const listSearchSchema = z.object({
  q: z.string().optional().catch(undefined),
  entry: z.string().optional().catch(undefined),
  edit: z.boolean().optional().catch(undefined),
});
